import { render, staticRenderFns } from "./drawBox.vue?vue&type=template&id=07531667&scoped=true"
import script from "./drawBox.vue?vue&type=script&lang=js"
export * from "./drawBox.vue?vue&type=script&lang=js"
import style0 from "./drawBox.vue?vue&type=style&index=0&id=07531667&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07531667",
  null
  
)

export default component.exports